import { dealStatus } from '@openx/types/deal.ts';

export const DEALS_RESOURCE_TYPE = 'deals';

export const DEALS_LANDING_RESOURCE_TYPE = 'dealsLanding';

export const getDealStatuses4Form = (t = s => s) => ({
  [dealStatus.Active]: t('Active'),
  [dealStatus.Paused]: t('Paused'),
});
